module.exports = __webpack_public_path__ + "img/partner1.b54020f9.png";